import { onBeforeUnmount, ref, watch } from "vue";
export function useTruncationDetector(spanRef, text) {
    const isTruncated = ref(false);
    let observer = null;
    function measure() {
        const el = spanRef.value;
        if (!el) {
            isTruncated.value = false;
            return;
        }
        isTruncated.value = el.scrollWidth > el.offsetWidth;
    }
    watch(spanRef, (el) => {
        observer?.disconnect();
        observer = null;
        if (!el) {
            isTruncated.value = false;
            return;
        }
        observer = new ResizeObserver(measure);
        observer.observe(el);
        measure();
    }, { flush: "post" });
    watch(text, () => {
        measure();
    }, { flush: "post" });
    onBeforeUnmount(() => {
        observer?.disconnect();
        observer = null;
    });
    return { isTruncated };
}
